import { render } from "./JobCollabTask.vue?vue&type=template&id=319c8f36"
import script from "./JobCollabTask.vue?vue&type=script&lang=js"
export * from "./JobCollabTask.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__